import { useContext, useEffect, useState } from 'react';
import { VolumeSlider } from '../widgets/VolumeSlider';
import { faMicrophone, faMicrophoneSlash, faVolume, faVolumeSlash } from '@fortawesome/pro-light-svg-icons';
import { Select } from '../widgets/Select';
import { PlaycastContext } from '../PlaycastWrapper';

export const VolumeManager = () => {
  const context = useContext(PlaycastContext);
  const [desktopVolume, setDesktopVolume] = useState(context.stateStores.audioState.desktopAudioVolume);
  const [micVolume, setMicVolume] = useState(context.stateStores.audioState.microphoneVolume);

  const [isDesktopUnmuted, setIsDesktopUnmuted] = useState(!context.stateStores.audioState.desktopAudioMuted);
  const [isMicUnmuted, setIsMicUnmuted] = useState(!context.stateStores.audioState.microphoneMuted);

  const [desktopAudioDevices, setDesktopAudioDevices] = useState(
    context.stateStores.audioState.desktopAudioSources.map((source) => {
      return { label: source.label, value: source.deviceId, enabled: source.selected };
    }),
  );
  const [micDevices, setMicDevices] = useState(
    context.stateStores.audioState.microphoneSources.map((source) => {
      return { label: source.label, value: source.deviceId, enabled: source.selected };
    }),
  );
  const [selectedDesktopDevice, setSelectedDesktopDevice] = useState(
    context.stateStores.audioState.desktopAudioSources.find((source) => source.selected)?.deviceId || '',
  );
  const [selectedMicDevice, setSelectedMicDevice] = useState(
    context.stateStores.audioState.microphoneSources.find((source) => source.selected)?.deviceId || '',
  );

  useEffect(() => {
    setDesktopVolume(context.stateStores.audioState.desktopAudioVolume);
    setMicVolume(context.stateStores.audioState.microphoneVolume);
  }, [context.stateStores.audioState.desktopAudioVolume, context.stateStores.audioState.microphoneVolume]);

  useEffect(() => {
    setIsDesktopUnmuted(!context.stateStores.audioState.desktopAudioMuted);
    setIsMicUnmuted(!context.stateStores.audioState.microphoneMuted);
  }, [context.stateStores.audioState]);

  useEffect(() => {
    setDesktopAudioDevices(
      context.stateStores.audioState.desktopAudioSources.map((source) => {
        return { label: source.label, value: source.deviceId, enabled: true };
      }),
    );
    setMicDevices(
      context.stateStores.audioState.microphoneSources.map((source) => {
        return { label: source.label, value: source.deviceId, enabled: true };
      }),
    );
    setSelectedDesktopDevice(context.stateStores.audioState.desktopAudioSources.find((source) => source.selected)?.deviceId || '');
    setSelectedMicDevice(context.stateStores.audioState.microphoneSources.find((source) => source.selected)?.deviceId || '');
  }, [context.stateStores.audioState.desktopAudioSources, context.stateStores.audioState.microphoneSources]);

  useEffect(() => {
    handleDesktopMute();
  }, [isDesktopUnmuted]);
  useEffect(() => {
    handleMicMute();
  }, [isMicUnmuted]);

  const handleDesktopVolumeChange = () => {
    const volume = desktopVolume;
    // console.log('desktop volume changed', volume);
    context.targetFunctions.setDesktopAudioVolume(volume);
  };
  const handleMicVolumeChange = () => {
    const volume = micVolume;
    // console.log('mic volume changed', volume);
    context.targetFunctions.setMicrophoneVolume(volume);
  };
  const handleDesktopMute = () => {
    console.log('[VolumeManager] Desktop Unmuted?', isDesktopUnmuted);
    context.targetFunctions.setDesktopAudioMuted(!isDesktopUnmuted);
  };
  const handleMicMute = () => {
    console.log('[VolumeManager] Mic Unmuted?', isMicUnmuted);
    context.targetFunctions.setMicrophoneMuted(!isMicUnmuted);
  };

  const handleDesktopAudioChange = (deviceId: string) => {
    setSelectedDesktopDevice(deviceId);
    context.targetFunctions.setDesktopAudio(deviceId);
  };

  const handleMicChange = (deviceId: string) => {
    setSelectedMicDevice(deviceId);
    context.targetFunctions.setMicrophone(deviceId);
  };

  return (
    <div className='grid h-full w-full grid-cols-2 gap-2 md:h-fit' tabIndex={-1}>
      {/* desktop volume */}
      <div className='flex flex-1 flex-col justify-between' tabIndex={-1}>
        <VolumeSlider
          id='desktop-volume-button'
          onRelease={handleDesktopVolumeChange}
          volumeOverride={desktopVolume}
          volumeState={[desktopVolume, setDesktopVolume]}
          buttonState={[isDesktopUnmuted, setIsDesktopUnmuted]}
          enabledIcon={faVolume}
          disabledIcon={faVolumeSlash}
        />
        <Select data={desktopAudioDevices} selected={selectedDesktopDevice} onChange={handleDesktopAudioChange} />
      </div>

      {/* microphone volume */}
      <div className='flex flex-col justify-between' tabIndex={-1}>
        <VolumeSlider
          id='mic-volume-button'
          onRelease={handleMicVolumeChange}
          volumeOverride={micVolume}
          volumeState={[micVolume, setMicVolume]}
          buttonState={[isMicUnmuted, setIsMicUnmuted]}
          enabledIcon={faMicrophone}
          disabledIcon={faMicrophoneSlash}
        />
        <Select data={micDevices} selected={selectedMicDevice} onChange={handleMicChange} />
      </div>
    </div>
  );
};
